<template>
    <div>
        <htmlHeader :top_index="3" :menuCode="false" :crumbsShow="false" />
        <div class="caigou">
            <div class="caigoukuang">
                <div class="caigoubiaoti">
                    <div style="padding:40px 0 0 38px">
                        <p>批量发布采购需求</p>
                        <p class="caigoufubiaoti">把您的需求告诉科隆，我们来为您完成</p>
                    </div>
                    <div style="margin:auto;padding:20px 40px 0 40px">
                        <div>
                            <span>步骤一：</span>
                            <span class="buzhou">选择地区</span>
                            <a-select :value="from.province ? from.province : '请选择省'" @change="sheng_Change">
                                <a-select-option :key="index" v-for="(item, index) in all_available" :value="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                            <a-select :value="from.city ? from.city : '请选择市'" default-value="请选择市" @change="shi_Change">
                                <a-select-option :key="index" v-for="(item, index) in all_shi" :value="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                            <a-select :value="from.area ? from.area : '请选择区'" default-value="请选择区" @change="qu_Change">
                                <a-select-option :key="index" v-for="(item, index) in all_qu" :value="item.name">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                        <div style="border-top:1px solid #EDE9E9;height:1px;width:596px;margin:18px auto;"></div>
                        <div style="display:flex">
                            <span>步骤二：</span>
                            <div>
                                <div>
                                    <span class="buzhous">下载模板</span>
                                    <a :href="'/api/cdkelong_mall/find_goods_batch/public/downloadTemplate'" style="width: 84px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;margin-right:40px"> <img src="../assets/caigou/xiaicon.png" alt="" /> 点击下载模板</a>
                                    <span style="width: 182px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 16px;">下载模板，请填写完成后上传</span>
                                </div>
                                <div>
                                    <span class="buzhous">上传模板</span>
                                    <a-upload name="file" :file-list="fileList" :multiple="true" action="/api/file/upload" @change="handleChange" accept=".word,.excel,.docx,.doc,.xlsx,.xls">
                                        <a style="width: 84px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;line-height: 16px;margin-right:40px"> <img src="../assets/caigou/shang1.png" alt="" /> 上传需求文件</a>
                                        <span style="width: 182px;height: 14px;font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;line-height: 16px;">上传文件后，科隆会与您取得联系</span>
                                    </a-upload>
                                </div>
                            </div>
                        </div>
                        <div style="border-top:1px solid #EDE9E9;height:1px;width:596px;margin:18px auto"></div>
                        <div style="display:flex">
                            <span style="width:145px">步骤三：</span>
                            <span class="buzhou" style="width:108px">确认信息</span>
                            <div>
                                <a-input placeholder="请输入公司/单位名称" style="margin:0 0 15px 0;height:40px;border-radius:0" v-model="from.gongsi" />
                                <a-input placeholder="请输入联系人姓名" style="margin:0 0 15px 0;height:40px;border-radius:0" v-model="from.name" />
                                <a-input placeholder="请输入联系电话" style="margin:0 0 15px 0;height:40px;border-radius:0" v-model="from.phone" />
                            </div>
                        </div>
                        <div style="display:flex;justify-content:center;">
                            <a-button style="width: 160px;height: 40px;background: #2B9A34;color: #FFFFFF;margin:10px;border-radius:0" @click="tijiao">立即提交</a-button>
                        </div>
                    </div>
                </div>
                <img src="../assets/caigou/right.png" alt="" />
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
const KEY = 'PurchaseConfig';
export default {
    name: 'News',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            all_available: '', // 所有省份
            all_shi: '', // 下级市
            all_qu: '', // 下级区
            from: {
                provinceId: '',
                province: '',
                cityId: '',
                city: '',
                areaId: '',
                area: '',
                gongsi: null,
                name: null,
                phone: null,
                wenjianid: null
            },
            moban: {
                id: '',
                name: ''
            },
            fileList: []
        };
    },
    created() {
        // 获取地址资源
        this.api.get_all_available().then(res => {
            this.all_available = res.data;
        });
        this.huoqu();
    },
    methods: {
        // 获取下载地址
        huoqu() {
            this.api.advertisementSet(KEY).then(res => {
                this.moban.name = res.data.name;
                this.moban.id = res.data.id;
            });
        },
        //上传
        handleChange(info) {
            let fileList = [...info.fileList];
            this.fileList = fileList.slice(-1);
            if (info.file.status === 'done') {
                this.$message.success('上传成功');
                this.from.wenjianid = info.file.response.data.uuid;
            } else if (info.file.status === 'error') {
                this.$message.error('上传失败，请重新上传');
                info.fileList.pop();
            }
        },
        // 切换地址
        sheng_Change(e) {
            this.from.province = e;
            this.all_available.forEach(element => {
                if (element.name == e) {
                    this.from.provinceId = element.id;
                    this.all_shi = element.children;
                }
            });
        },
        shi_Change(e) {
            this.from.city = e;
            this.all_shi.forEach(element => {
                if (element.name == e) {
                    this.from.cityId = element.id;
                    this.all_qu = element.children;
                    if (element.name == '成都市') {
                        this.from.ring = '';
                        this.sanhuan_show = true;
                    } else {
                        this.sanhuan_show = false;
                        delete this.from['ring'];
                    }
                }
            });
        },
        qu_Change(e) {
            this.from.area = e;
            this.all_qu.forEach(element => {
                if (element.name == e) {
                    this.from.areaId = element.id;
                    this.all_qu2 = element.children;
                }
            });
        },
        // 清空
        qingkong() {
            this.from.province = '';
            this.from.city = '';
            this.from.area = '';
            this.from.gongsi = '';
            this.from.name = '';
            this.from.phone = '';
            this.from.wenjianid = '';
        },
        tijiao() {
            if (localStorage.getItem('uuid')) {
                if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.from.phone)) {
                    this.$message.error('请输入正确电话号码');
                    return false;
                }
                if (this.from.areaId && this.from.wenjianid && this.from.gongsi && this.from.name && this.from.phone) {
                    const a = {
                        attachment: this.from.wenjianid,
                        company: this.from.gongsi,
                        contacts: this.from.name,
                        contactsTel: this.from.phone,
                        district: {
                            district1: this.from.province,
                            district2: this.from.city,
                            district3: this.from.area,
                            district1Id: this.from.provinceId,
                            district2Id: this.from.cityId,
                            district3Id: this.from.areaId
                        },
                        remarks: '',
                        contactRemarks: '1',
                        userId: localStorage.getItem('uuid')
                    };
                    this.api.piliangcaigou({ ...a }).then(res => {
                        console.log(res, '提交请求');
                        if (res.ok === true) {
                            this.$message.success(res.message);
                            this.qingkong();
                            this.fileList = [];
                        } else {
                            window.open(`/api/common/public/download?fileName=${res.data.msg}`, '_blank');
                            this.$message.error(res.message);
                        }
                    });
                } else {
                    this.$message.error('请确认所有步骤已完成');
                }
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        }
    }
};
</script>

<style scoped>
p {
    padding: 0;
    margin: 0;
}
.caigou {
    background-image: url(../assets/caigou/bg.png);
    width: 100%;
    height: 790px;
    padding: 112px 0;
}
.caigoukuang {
    width: 1000px;
    height: 567px;
    background: #ffffff;
    border-radius: 10px;
    margin: auto;
    display: flex;
    justify-content: space-between;
}
.caigoubiaoti {
    width: 650px;
    height: 44px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
}
.caigoufubiaoti {
    width: 500px;
    height: 44px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
}
.buzhou {
    font-size: 14px;
    font-weight: bold;
    margin-right: 10px;
}
.buzhous {
    font-size: 14px;
    font-weight: bold;
    margin-left: 6px;
    margin-right: 13px;
}
.buzhous::before {
    content: '* ';
    color: red;
}
.buzhou::before {
    content: '* ';
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase.vue